import dynamicYieldClient from 'src/utils/dynamicYield/dynamicYieldClient'

import { ensureDYCookies } from './dynamicYieldCookies'
import type { DynamicYieldEvents } from './types/dynamicYieldTypes'

/**
 * Sends one or more events to Dynamic Yield.
 *
 * - Ensures the user ID (`_dyid`) and session ID (`_dyjsession`) cookies are set.
 * - Constructs the payload with user, session, context, and event information.
 * - Sends the event(s) to the Dynamic Yield `/event` endpoint.
 *
 * @param {Object} params - Parameters for the event tracking.
 * @param {DynamicYieldEvent[]} params.events - Array of events to be sent (e.g., Add To Cart, Remove from Cart).
 *
 * @returns {Promise<void>} Resolves when the event has been successfully sent or logs an error.
 */
export default async function dynamicYieldEvents(events: DynamicYieldEvents) {
  try {
    const { dyid, dyidServer, sessionId } = await ensureDYCookies()

    const eventsViewData = {
      user: { active_consent_accepted: true, dyid_server: dyidServer, dyid },
      session: { dy: sessionId },
      context: { channel: 'WEB' },
      events,
    }

    if (!dyid || !sessionId || !dyidServer) {
      return
    }

    const result = await dynamicYieldClient.post('/event', eventsViewData)

    console.info(`Dynamic Yield (${events[0].name}): `, result?.data)
  } catch (error) {
    console.error(
      `Error sending Dynamic Yield page (${events[0].name}): `,
      error
    )
  }
}
